export const ORDER_TYPE = "ORDER_TYPE";
export const ORDER_TIME = "ORDER_TIME";
export const ORDER_LATER_DATETIME = "ORDER_LATER_DATETIME"
export const PAYMENT_METHOD = "PAYMENT_METHOD";
export const ORDER = "ORDER";
export const PAYMENT = "PAYMENT";
export const DELIVERY_ADDRESS = "DELIVERY_ADDRESS"
export const GEOCODED_ADDRESS = "GEOCODED_ADDRESS"
export const EXTRA_ADDRESS = "EXTRA_ADDRESS"
export const SAVE_HBL_BANK_DATA = "SAVE_HBL_BANK_DATA"
export const ACTIVE_PAYMENT_MODES = "ACTIVE_PAYMENT_MODES"
export const PICKUP_TIME = "PICKUP_TIME"
export const SET_POSITION = "SET_POSITION"
export const SET_SEARCH_STRING = "SET_SEARCH_STRING"
export const SET_TAX = "SET_TAX"